import React, { useEffect, useRef } from 'react';
import { Cell, CellProps } from '@blueprintjs/table';

interface IProps extends CellProps {
    value: string;
    setValue: (value: string) => void;
    options: Record<string, string>;
    readOnly?: boolean;
    isFocused?: boolean;
}

export default function DropdownCell(props: IProps) {
    const { value, setValue, options, readOnly, isFocused, ...cellProps } = props;
    const selectRef = useRef<HTMLSelectElement>(null);

    useEffect(() => {
        if (isFocused) {
            selectRef.current?.focus();
        }
    }, [isFocused]);

    const optionEntries = Object.entries(options);

    return (
        <Cell
            className={cellProps.className}
            loading={cellProps.loading}
            style={{ ...cellProps.style, padding: 1, margin: 0 }}
            cellRef={cellProps.cellRef}
        >
            <select
                ref={selectRef}
                className='text-gray-900 text-sm border-0 pl-2 font-gray-500 p-0 focus:outline-none focus:ring-2 focus:ring-blue-500'
                value={value}
                onChange={(event) => setValue(event.target.value)}
                onKeyDown={(event) => {
                    if (event.key === 'Backspace' && value) {
                        setValue('');
                    }
                }}
                disabled={readOnly}
                style={{ width: '100%', height: '100%' }}
            >
                <option value='' />
                {optionEntries.map(([label, optionValue]) => (
                    <option key={optionValue} value={optionValue}>
                        {label}
                    </option>
                ))}
            </select>
        </Cell>
    );
}
